module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Bold.deba13d.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Bold.eot
// module id = OJoK
// module chunks = 1